module.exports = __webpack_public_path__ + "img/ricelog_pinicon_023.b6bd86e2.png";